import React from 'react';
import {Platform, StyleSheet} from 'react-native';

import Text, {TextProps} from './Text';

/**
 * Themed Text variant with a platform-appropriate monospace font.
 * Use for code snippets, barcode labels, card numbers — anywhere
 * evenly-spaced characters are needed.
 */
const MonospaceText = ({style, children, ...props}: TextProps) => (
  <Text style={[styles.monospace, style]} {...props}>
    {children}
  </Text>
);

const styles = StyleSheet.create({
  monospace: {
    fontFamily: Platform.OS === 'ios' ? 'Courier' : 'monospace',
  },
});

export default MonospaceText;
